import InnerWrapper from '../InnerWrapper'
import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'
import Modal from 'components/Modal'
import TSTable from 'components/Tanstack'

import BankAccountsUpdateModalForm from './BankAccountsUpdateModalForm/Form'
import { useMerchantBankAccounts } from './useMerchantBankAccounts'
import { useMerchantBankAccountsTable } from './useMerchantBankAccountsTable'

const Index = (): JSX.Element => {
  const { merchantBankAccounts, merchantBankAccountsModStatus } =
    useMerchantBankAccounts()

  const {
    merchantBankAccountsActionModal,
    merchantBankAccountsSelected,
    merchantBankAccountsTableData,
    merchantBankAccountsTableColumns,
    handleMerchantActionModalClose,
  } = useMerchantBankAccountsTable()

  return (
    <>
      <InnerWrapper title="Bank Accounts">

        {/* FAIL */}
        {merchantBankAccountsModStatus === 'fail' ? (
          <NoResults
            header="Failed to load data"
            subtitle="Please refresh the page and try again, or contact
        your system administrator"
            noImage
          />
        ) : null}

        {/* LOADING */}
        {merchantBankAccountsModStatus === 'loading' ? <Spinner /> : null}

        {/* SUCCESS */}
        {merchantBankAccounts.length &&
        merchantBankAccountsModStatus === 'success' ? (
          <>
            <TSTable.Table
              data={merchantBankAccountsTableData}
              columns={merchantBankAccountsTableColumns}
            />
          </>
        ) : null}

        {/* EMPTY */}
        {!merchantBankAccounts.length &&
        merchantBankAccountsModStatus === 'success' ? (
          <>
            <NoResults
              header="No available data"
              subtitle="There is no available data to display"
              noImage
            />
          </>
        ) : null}
      </InnerWrapper>

      {/* UPDATE BANK ACCOUNT */}
      {merchantBankAccountsActionModal === 'merchant_bank_accounts_update' &&
      merchantBankAccountsSelected ? (
        <Modal
          open={true}
          title="Update Bank Account"
          onClose={handleMerchantActionModalClose}
          noFooter
        >
          <BankAccountsUpdateModalForm
            onCloseModal={handleMerchantActionModalClose}
            selectedMerchantBankAccount={merchantBankAccountsSelected}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default Index
